import { render, staticRenderFns } from "./QuerySummary.vue?vue&type=template&id=5766a78a&"
import script from "./QuerySummary.vue?vue&type=script&lang=ts&"
export * from "./QuerySummary.vue?vue&type=script&lang=ts&"
import style0 from "./QuerySummary.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\koen\\workspace\\cf2\\src\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5766a78a')) {
      api.createRecord('5766a78a', component.options)
    } else {
      api.reload('5766a78a', component.options)
    }
    module.hot.accept("./QuerySummary.vue?vue&type=template&id=5766a78a&", function () {
      api.rerender('5766a78a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/search/results/QuerySummary.vue"
export default component.exports